// App version

const VERSION = "3.4.1";

export default VERSION;
